































import { Component, Prop, Vue } from "vue-property-decorator";
import { identitasDariStore } from "@/utils/identitasPasienRingkas";
import type { IdentitasRingkas } from "@/types/order_darah";

@Component
export default class IdentitasPasienRingkas extends Vue {
  @Prop() readonly register!: string | number;

  @Prop({ default: null }) readonly data!: Partial<IdentitasRingkas> | null;

  @Prop({ default: null }) readonly rm!: string | number | null;

  get identitas(): IdentitasRingkas {
    const dasar = this.data ? null : identitasDariStore(this.register);
    if (dasar) return dasar;

    const d = this.data || {};
    return {
      nama: d.nama || "-",
      jk: d.jk || "-",
      usia: d.usia || "-",
      alamat: d.alamat || "-",
      jaminan: d.jaminan || "-"
    };
  }
}
